// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__eEy6I","First":"Table_First__rjfXi"};